import { render, staticRenderFns } from "./CardCollection.vue?vue&type=template&id=4041fca2&scoped=true&"
import script from "./CardCollection.vue?vue&type=script&lang=js&"
export * from "./CardCollection.vue?vue&type=script&lang=js&"
import style0 from "./CardCollection.vue?vue&type=style&index=0&id=4041fca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041fca2",
  null
  
)

export default component.exports